import BaseAPI from '../baseApi';
import { Cart, UpdateCart } from '../interfaces';
import { configuration } from '../../configuration';
import { v4 } from 'uuid';

export class CartApi extends BaseAPI {
  model = 'cart';

  get host(): string {
    return configuration.minibarUrl;
  }

  async headers(): Promise<Record<string, string>> {
    return await this.minibarHeaders();
  }

  getCart(id: number): Promise<Cart> {
    return this.get<Cart>(`${id}`);
  }

  create(): Promise<Cart> {
    const storefrontCartId = v4();
    const cart = this.post<Cart>('', { storefrontCartId });

    return cart;
  }

  update(id: number, cart: UpdateCart): Promise<Cart> {
    return this.put<Cart>(`${id}`, cart);
  }
}
